// Module
var code = "<ul class=\"ui list mentions__list\"> <li ng-repeat=\"user in items\" class=\"item addcursor\" mentio-menu-item=\"user\"> <avatar-display class=\"user__avatar--micro\" user=\"user\"></avatar-display> <span class=\"content text-primary\" ng-bind-html=\"user.full_name | escapedHighlight:typedTerm:'user-name-highlighted'\"></span> </li> </ul>";
// Exports
module.exports = code;